import i18n from 'modules/core/lib/i18n'
import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

interface Tab {
  name: string
  index: boolean
  href: string
}

const buildTabs = (navigation: Navigation<NavigationPaths>): Tab[] => {
  const tabs = [
    {
      name: i18n.t('settings.timeoff_policies.list.title'),
      index: true,
      href: navigation.settings.timeoffPolicies.policies.fullPath(),
    },
    {
      name: i18n.t('settings.leave_types.list.title'),
      index: false,
      href: navigation.settings.timeoffPolicies.absenceTypes.fullPath(),
    },
    {
      name: i18n.t('settings.time_off.approvals.title'),
      index: false,
      href: navigation.settings.timeoffPolicies.approvalGroups.fullPath(),
    },
    {
      name: i18n.t('settings.time_off.blocked_periods.title'),
      index: false,
      href: navigation.settings.timeoffPolicies.blockedPeriods.fullPath(),
    },
  ]

  return tabs
}

export { buildTabs }
